import { render, staticRenderFns } from "./BoutonGestionBarquettes.vue?vue&type=template&id=ce878ed6&"
import script from "./BoutonGestionBarquettes.vue?vue&type=script&lang=js&"
export * from "./BoutonGestionBarquettes.vue?vue&type=script&lang=js&"
import style0 from "./BoutonGestionBarquettes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports